<template>
  <!--
    Kontener z dynamicznymi klasami (container lub container2 oraz fieldName).
    Obsługuje kliknięcia, ale tylko jeśli nie jest disabled.
  -->
  <span :class="[containerClass, fieldName]" @click="handleClick">
    <!--
      Ukryty checkbox. Kontrolowany przez props:
      - fieldName: nazwa pola
      - fieldValue: wartość
      - checkedCondition: czy zaznaczony (Boolean)
      - disabled: czy zablokowany
      - class: tylko styl, nie wpływa na funkcjonalność
    -->
    <input
      :name="fieldName"
      type="checkbox"
      :value="fieldValue"
      :checked="checkedCondition"
      :disabled="disabled"
      class="checkbox"
    />
    <!--
      "Sztuczny" checkmark czyli własny styl zaznaczenia, zamiast natywnego checkboxa.
      Klasa checkmarkClass decyduje o stylu (np. 'checkmark' lub 'vio')
    -->
    <span :class="checkmarkClass"></span>
  </span>
</template>

<script setup>
// Importujemy funkcje reaktwyne z Vue
import { computed } from 'vue';

// Definiujemy wejściowe propsy
const props = defineProps({
  fieldName: {
    type: [String, Number],
  },
  fieldValue: String,
  checkedCondition: Boolean, // Czy checkbox jest zaznaczony
  disabled: Boolean,         // Czy pole jest zablokowane
  vio: String,               // Jeśli podany, używa klasy 'vio' do stylowania
});

// Definiujemy możliwe eventy, które komponent emituje
const emit = defineEmits(["clicked"]);

// Obsługa kliknięcia w kontenerze checkboxa
const handleClick = () => {
  if (props.disabled) return; // Ignoruj kliknięcia, jeśli disabled
  emit("clicked");
};

// Określenie klasy kontenera: domyślnie 'container', jeśli vio to 'container2'
const containerClass = computed(() => {
  return props.vio ? 'container2' : 'container';
});

// Określenie klasy dla checkmarka: domyślnie 'checkmark', jeśli vio to wartość z vio (np. 'vio')
const checkmarkClass = computed(() => {
  return props.vio ? props.vio : 'checkmark';
});
</script>

<style scoped>
/* Kontener podstawowy */
.container {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  position: relative;
  cursor: pointer;
  width: 100%;
  height: 100%;
  font-size: 22px;
  user-select: none;
}

/* Kontener alternatywny (gdy vio jest ustawione) */
.container2 {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  position: relative;
  cursor: pointer;
  user-select: none;
}

/* Ukrycie natywnego checkboxa */
.container input, .container2 input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Wizualny checkmark (kółko) */
.checkmark {
  position: absolute;
  height: 16px;
  width: 16px;
  border-radius: 15px;
  border: 1px solid #656565;
}

/* Alternatywny checkmark (np. do stylowania naruszeń) */
.vio {
  position: absolute;
  height: 16px;
  width: 16px;
  border-radius: 15px;
  border: 1px solid #656565;
}

/* Hover na kontenerze: przyciemnia tło checkmarka */
.container:hover input ~ .checkmark, .container2:hover input ~ .vio {
  background-color: #ccc;
}

/* Jeśli zaznaczony: wypełnij kółko kolorem */
.container input:checked ~ .checkmark, .container2 input:checked ~ .vio {
  background-color: #656565;
}

/* Ukryta pseudo-zaznaczenie (do customowych efektów, np. ramka) */
.checkmark:after, .vio:after {
  content: "";
  position: absolute;
  display: none;
}

/* Wyświetl ramkę, jeśli checkbox jest zaznaczony */
.container input:checked ~ .checkmark:after, .container2 input:checked ~ .vio:after {
  display: block;
}

.container .checkmark:after, .container2 .vio:after {
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  border: 2px solid #f5f4f2;
  border-radius: 12px;
}
</style>
